import { CommonModule } from '@angular/common';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/AppConfig';
import { DestacadosModel } from 'src/app/models/destacados.model';
import { DestacadosService } from 'src/app/services/destacados.service';
import { Carousel } from 'bootstrap';

@Component({
    selector: 'app-carrusel',
    imports: [CommonModule],
    templateUrl: './carrusel.component.html',
    styleUrls: ['./carrusel.component.css'],
    standalone: false
})
export class CarruselComponent implements OnInit {
  @ViewChildren('allThese') things: QueryList<any>;

  
  inmuebles: DestacadosModel[] = [/* 
    { precio: 4073000.56, region: "Zona Norte", folio: "1", tipoInmueble: "Vivienda", subtipoInmueble: "", estado: "Edo. de México", municipio: "Tecamac", estatus: 1, metros: 300, imagenes: []},
    { precio: 10420000.00, region: "Zona Norte", folio: "1", tipoInmueble: "Casa", subtipoInmueble: "", estado: "", municipio: "", estatus: 1, metros: 300, imagenes: [{idImagen: 1, principal: 1, ruta: "https://i.pinimg.com/originals/e8/aa/a2/e8aaa218f1a475e95ca09ac8def2e83e.jpg", promotor: "", folio: ""}]},
    { precio: 9168000.00, region: "Zona Centro", folio: "1", tipoInmueble: "Casa", subtipoInmueble: "", estado: "", municipio: "", estatus: 0, metros: 300, imagenes: [{idImagen: 1, principal: 1, ruta: "https://i.pinimg.com/originals/e8/aa/a2/e8aaa218f1a475e95ca09ac8def2e83e.jpg", promotor: "", folio: ""}]},
    { precio: 3045315.00, region: "Zona Occidente", folio: "1", tipoInmueble: "Casa", subtipoInmueble: "", estado: "", municipio: "", estatus: 1, metros: 300, imagenes: [{idImagen: 1, principal: 1, ruta: "https://i.pinimg.com/originals/e8/aa/a2/e8aaa218f1a475e95ca09ac8def2e83e.jpg", promotor: "", folio: ""}]},
    { precio: 8619842.00, region: "Zona Norte", folio: "1", tipoInmueble: "Casa", subtipoInmueble: "", estado: "", municipio: "", estatus: 0, metros: 300, imagenes: [{idImagen: 1, principal: 1, ruta: "https://i.pinimg.com/originals/e8/aa/a2/e8aaa218f1a475e95ca09ac8def2e83e.jpg", promotor: "", folio: ""}]},
    { precio: 845913.00, region: "Zona Centro", folio: "1", tipoInmueble: "Casa", subtipoInmueble: "", estado: "", municipio: "", estatus: 1, metros: 300, imagenes: [{idImagen: 1, principal: 1, ruta: "https://i.pinimg.com/originals/e8/aa/a2/e8aaa218f1a475e95ca09ac8def2e83e.jpg", promotor: "", folio: ""}]},
    { precio: 3045315.00, region: "Zona Occidente", folio: "1", tipoInmueble: "Casa", subtipoInmueble: "", estado: "", municipio: "", estatus: 1, metros: 300, imagenes: [{idImagen: 1, principal: 1, ruta: "https://i.pinimg.com/originals/e8/aa/a2/e8aaa218f1a475e95ca09ac8def2e83e.jpg", promotor: "", folio: ""}]},
    { precio: 8619842.00, region: "Zona Norte", folio: "1", tipoInmueble: "Casa", subtipoInmueble: "", estado: "", municipio: "", estatus: 0, metros: 300, imagenes: [{idImagen: 1, principal: 1, ruta: "https://i.pinimg.com/originals/e8/aa/a2/e8aaa218f1a475e95ca09ac8def2e83e.jpg", promotor: "", folio: ""}]},
    { precio: 845913.00, region: "Zona Centro", folio: "1", tipoInmueble: "Casa", subtipoInmueble: "", estado: "", municipio: "", estatus: 1, metros: 300, imagenes: [{idImagen: 1, principal: 1, ruta: "https://i.pinimg.com/originals/e8/aa/a2/e8aaa218f1a475e95ca09ac8def2e83e.jpg", promotor: "", folio: ""}]},
    */];
  urlBase: string = "";
  esVacia: boolean = false;
  listo: boolean = false;
 
  destacados: any[][] = [];
  screenWidth: number = window.innerWidth;
 
  constructor(private destacadosService: DestacadosService,
    private routes: Router,
     private appConfig: AppConfig 
  ) {
 
    this.urlBase = this.appConfig.getConfig('base_url');
    this.destacadosService.obtenerMasDestacados().subscribe(response => {
      this.esVacia = false;
      this.inmuebles = response.respuesta;
      this.listo = true;
      if (this.inmuebles.length == 0) {
        this.esVacia = true;
      }else if(this.inmuebles.length > 0){
        this.listo = true;
        this.ajustarSlide();
      }
    }, err => {
      /* this.esVacia = false;
      this.listo = true;
      this.ajustarSlide(); */
    });
  }

  ngAfterViewInit() {
    this.things.changes.subscribe(t => {
      this.ajustarSlide();
    })
  }
 
  ngOnInit() {
    window.addEventListener('resize', () =>{
      this.ajustarSlide();
    } );
    setTimeout(() => {
      // @ts-ignore
      this.moverCarrusel(1);
      //this.lblBtnCerrarModal = this.CANCELAR;
      //this.mostrarFormRecomendarInmueble = true;
    }, 3000);
  }
 
  chunkArray(arr: any[], size: number) {
    return arr.reduce((acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]), []);
  }

  load(){
    console.log("cargando");
  }
  
  public detalleInmueble(folio: string) {
    window.scrollTo(0, 0);
    this.routes.navigate(['/detalle', folio]);
  }

  ajustarSlide() {
    let cardsPorSlide = 3;
    if (window.innerWidth < 992) {
      cardsPorSlide = 2;
    }
    if (window.innerWidth < 768) {
      cardsPorSlide = 1;
    }
    if (cardsPorSlide === 3) {
      const regiones = [...new Set(this.inmuebles.map(inmueble => inmueble.region))];
      let agrupados: DestacadosModel[] = [];
      regiones.forEach(region => {
        agrupados = agrupados.concat(this.inmuebles.filter(inmueble => inmueble.region === region));
      });
      this.destacados = this.chunkArray(agrupados, cardsPorSlide);
    } else {
      this.destacados = this.chunkArray(this.inmuebles, cardsPorSlide);
    }
  }

  moverCarrusel(direccion: number) {
    const el = document.querySelector('#carouselDestacados');
    if (el) {
      const carousel = Carousel.getInstance(el) || new Carousel(el);
      direccion === -1 ? carousel.prev() : carousel.next();
    }
  }
}